<input
  class="peer sr-only"
  [type]="base.inputType()"
  [id]="base.id()"
  [checked]="base.isChecked()"
  [attr.name]="base.resolvedName()"
  [attr.value]="base.value()"
  [disabled]="base.isDisabled()"
  (change)="base.onInputChange($event)"
  (click)="base.onInputClick()"
/>
<label [class]="labelClasses()" [for]="base.id()">
  @let cardIcon = icon();
  @if (cardIcon) {
    <sb-icon [name]="cardIcon" size="xl" class="shrink-0" />
  }
  <div
    class="flex min-w-0 flex-col gap-sm"
    [class.flex-1]="layout() === 'inline'"
    [class.items-center]="layout() === 'stacked'"
  >
    <div
      class="flex min-w-0 items-center gap-sm"
      [class.justify-between]="layout() === 'inline'"
      [class.justify-center]="layout() === 'stacked'"
    >
      <ng-content />
      @if (badge()) {
        <sb-badge [color]="'brandInverted'">{{ badge() }}</sb-badge>
      }
    </div>
    <div class="font-normal text-support empty:hidden">
      <ng-content select="[description]" />
    </div>
  </div>
</label>
